import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { sanitizeFieldName } from '../util/methods';
import Asset from '../containers/Asset';
import EquipmentSubType from '../containers/EquipmentSubType';
import AssetReceiptNote from '../containers/AssetReceiptNote';
import AssetService from '../containers/AssetService';
import AssetTransferAdvice from '../containers/AssetTransferAdvice';
import AssetType from '../containers/AssetType';
import AssetClassification from '../containers/AssetClassification';
import Client from '../containers/Client';
import Document from '../containers/Document';
import DocumentType from '../containers/DocumentType';
import JobCard from '../containers/JobCard';
import Location from '../containers/Location';
import Manpower from '../containers/Manpower';
import PurchaseOrder from '../containers/PurchaseOrder';
import Resource from '../containers/Resource';
import Role from '../containers/Role';
import SaleOrder from '../containers/SaleOrder';
import SalesReport from '../containers/SaleOrder/sales-report';
import Sidebar from '../containers/Sidebar';
import SparePartTransaction from '../containers/SparePartTransaction';
import SparePartType from '../containers/SparePartType';
import SubAssetTransfer from '../containers/SubAssetTransfer';
import User from '../containers/User';
import Organisation from '../containers/Organisation';
import Vendor from '../containers/Vendor';
import Owner from '../containers/Owner';
import JobType from '../containers/JobType';
import ManpowerPerformance from '../containers/ManpowerPerformance';
import Interval from '../containers/Interval';
import AssetRefurbishTransaction from '../containers/AssetRefurbishTransaction';
import UnitOfMeasurement from '../containers/UnitOfMeasurement';
import SparePart from '../containers/SparePart';
import SpareTransferAdvice from '../containers/SpareTransferAdvice';
import SpareReceiptAdvise from '../containers/SpareReceiptAdvise';
import Complaint from "../containers/Complaint";
import Activity from "../containers/Activity";
import JobCardAllocation from "../containers/JobCardAllocation";
import JobCardStatusUpdate from "../containers/JobCardStatusUpdate";
import ActivityType from "../containers/ActivityType";
import JobCardClosure from "../containers/JobCardClosure";
import Log from "../containers/Log";
import SparesIssue from "../containers/SparesIssue";
import SpareStockTaking from "../containers/SpareStockTaking";
import SparesReconciliation from "../containers/SparesReconciliation";
import SpareStockTakingAdjustmentDetails from "../containers/SpareStockTaking/adjustment-details";
import SpareAdjustmentVoucherReport from "../containers/SpareStockTaking/adjustment-voucher-report";
import Status from "../containers/Status";
import JobCardStatus from "../containers/JobCardStatus";
import FuelType from '../containers/FuelType';
import FuelReadingMethod from '../containers/FuelReadingMethod';
import FuelLevelReading from '../containers/FuelLevelReading';
import FleetTrip from '../containers/FleetTrip';
import Fuel from '../containers/Fuel';
import AssetStockTaking from "../containers/AssetStockTaking";
import AssetConditionVoucher from "../containers/AssetConditionVoucher";
import QrScanLog from "../containers/QrScanLog";
import ConditionOfAsset from '../containers/ConditionOfAsset';
import EmployeeAssetIssue from "../containers/EmployeeAssetIssue";
import EmployeeAssetReceipt from "../containers/EmployeeAssetReceipt";
import AssetModel from "../containers/AssetModel";
import Labour from '../containers/Labour';
import ThirdPartyWorkRequirement from "../containers/ThirdPartyWorkRequirement";
import ThirdPartyWorkQuotation from "../containers/ThirdPartyWorkQuotation";
import ThirdPartyWorkApproval from "../containers/ThirdPartyWorkApproval";
import InvoiceEntry from "../containers/InvoiceEntry";
import Event from "../containers/Event";
import ActivityClosure from "../containers/ActivityClosure";
import Notification from "../containers/notification";
import AssetDataImport from "../containers/AssetDataImport";
import SpareDataImport from "../containers/SpareDataImport";
import AssetMasterImport from "../containers/AssetMasterImport";
import SpareInventoryReport from "../containers/SparePart/sparepart-inventory";
import SpareCompatibility from '../containers/SparePart/compability';
import ChangePassword from "../containers/ChangePassword";
import PreVerification from '../containers/PreVerification';
import PreVerificationApproval from '../containers/PreVerificationApproval';
import NotificationSetting from "../containers/NotificationSetting";
import StockMethod from '../containers/StockMethod';
import FuelStatus from "../containers/FuelStatus";
import Leasing from "../containers/Leasing";
import Contract from "../containers/Contract";
import AssetMake from "../containers/AssetMake";
import DocumentRenewal from '../containers/DocumentRenewal';
import Dashboard from '../containers/Dashboard';
import SpareMerge from "../containers/SparePart/spare-merge";
import SparePartAttribute from "../containers/SparePartAttribute";
import SubAssembly from "../containers/SubAssembly";
import Task from "../containers/Task";
import PMSchedule from "../containers/ServiceIdentifier";
import PMChecklist from "../containers/PreventiveMaintenance";
import TaskComponent from "../containers/TaskComponent";
import TaskAction from "../containers/TaskAction";
import SubAssemblyReport from '../containers/SparePart/subAssemblyReport';
import AssetModelSpareIssueReport from '../containers/Asset/AssetSpareIssueReport';
import Setting from '../containers/Setting';
import ManpowerReminder from '../containers/ManpowerReminder';
import AssetTagging from '../containers/AssetLink';
import AssetTagType from '../containers/AssetTagType';
import AssetTagAttribute from '../containers/AssetTagAttribute';
import OrganisationType from '../containers/OrganisationType';
import RemoveOrganisationData from '../containers/RemoveOrganisationData';
import AssetManager from '../containers/AssetManager';
import PageSetting from '../containers/PageSetting';
import ManpowerAttendance from '../containers/ManpowerAttendance';
import DeviceDetails from '../containers/DeviceMap/deviceDetails';
import BleBeaconDetails from '../containers/BleBeacon';
import Alert from '../containers/Alert';

import './style.css'
import AuditVoucher from '../containers/AuditVoucher';
import FuelAdjustment from '../containers/FuelAdjustment';
import Reconciliation from '../containers/ReconciliationV3';
import SparesAudit from '../containers/SparesAudit';
import AssetReclassification from '../containers/AssetReclassification';
import ReconciliationLegacy from '../containers/Reconciliation';
import ManualAssetReading from '../containers/ManualAssetReading';
import FuelSensolCalibSlab from '../containers/Asset/FuelSensorCalibration';
import IotDevice from '../containers/IotDevice';
import Meter from '../containers/Meter';
import AssetMeterReading from '../containers/AssetMeterReading';
import ExternalRequestLog from '../containers/ExternalRequestLog';
import DailyReport from '../containers/IotDevice/daily_report';
import NewMeterImport from '../containers/NewMeterImport';
import BulkFuelImport from '../containers/BulkFuelImport';
import IotDeviceReport from '../containers/IotDevice/iot-device-report';
import IotDailyProcessCheck from '../containers/IotDevice/iot-daily-process-check';
import OpsTicketsReport from '../containers/IotDevice/ops-tickets-report';
import IotSettingPage from '../containers/Asset/iot-setting';
import BulkFuelProcess from '../containers/BulkFuelProcess';
import DailyFuelProcessReportNotification from '../containers/DailyFuelProcessReportNotification';
import BillingUnits from '../containers/BillingUnits';
import SpeedLimitBulkUpdate from '../containers/Asset/speed-limit';
import BulkAssetUpdate from '../containers/Asset/bulk-update';
// import IotJobCard from '../containers/IotJobCard';
import IotSupportJobsCardView from '../containers/JobCard/iot-support-jobs-card-view';
import GeoFence from '../containers/GeoFence';
import GeoFenceImport from '../containers/GeoFenceImport';
import PoiManager from '../containers/PoiManager';

const containers = {
       Asset,
       EquipmentSubType,
       AssetReceiptNote,
       AssetService,
       AssetTransferAdvice,
       AssetType,
       AssetClassification,
       Client,
       Document,
       DocumentType,
       JobCard,
       Location,
       Manpower,
       PurchaseOrder,
       Resource,
       Role,
       SaleOrder,
       Sidebar,
       SparePartTransaction,
       SparePartType,
       SubAssetTransfer,
       User,
       Organisation,
       Vendor,
       Owner,
       JobType,
       ManpowerPerformance,
       Interval,
       AssetRefurbishTransaction,
       UnitOfMeasurement,
       SparePart,
       SpareTransferAdvice,
       SpareReceiptAdvise,
       Complaint,
       Activity,
       ActivityType,
       Log,
       SparesIssue,
       SpareStockTaking,
       SparesReconciliation,
       Status,
       AssetStockTaking,
       AssetConditionVoucher,
       FuelType,
       FuelReadingMethod,
       FuelLevelReading,
       FleetTrip,
       Fuel,
       QrScanLog,
       ConditionOfAsset,
       EmployeeAssetIssue,
       EmployeeAssetReceipt,
       AssetModel,
       Labour,
       ThirdPartyWorkRequirement,
       ThirdPartyWorkQuotation,
       ThirdPartyWorkApproval,
       InvoiceEntry,
       ActivityClosure,
       Event,
       Notification,
       NotificationSetting,
       AssetDataImport,
       SpareDataImport,
       AssetMasterImport,
       ChangePassword,
       PreVerification,
       PreVerificationApproval,
       StockMethod,
       FuelStatus,
       Leasing,
       Contract,
       AssetMake,
       DocumentRenewal,
       Dashboard,
       SparePartAttribute,
       SubAssembly,
       Task,
       PMSchedule,
       PMChecklist,
       TaskComponent,
       TaskAction,
       Setting,
       ManpowerReminder,
       AssetTagging,
       AssetTagType,
       AssetTagAttribute,
       OrganisationType,
       RemoveOrganisationData,
       AssetManager,
       PageSetting,
       ManpowerAttendance,
       DeviceDetails,
       BleBeaconDetails,
       AuditVoucher,
       FuelAdjustment,
       Reconciliation,
       SparesAudit,
       ExternalRequestLog,
       ManualAssetReading,
       IotDevice,
       Meter,
       AssetMeterReading,
       NewMeterImport,
       BulkFuelImport,
       IotDeviceReport,
       BulkFuelProcess,
       // IotJobCard,
       IotSupportJobsCardView,
       IotSupportJobs: IotSupportJobsCardView
};

const hasPointOfInterestAccess = (authUser) => {
       if (!authUser) return false;
       if (authUser.superAdmin) return true;
       const permittedModules = (((authUser || {}).organisation || {}).assetProModules) || [];
       const hasTelematicsModule = Array.isArray(permittedModules) && permittedModules.includes('Telematics');
       if (!hasTelematicsModule) return false;
       const access = (authUser.roles || []).reduce((acc, role) => {
              return [...acc, ...((role && role.access) || [])];
       }, []);
       return access.some((entry) => (
              entry
              && entry.name === 'PointOfInterest'
              && Array.isArray(entry.permissions)
              && entry.permissions.length > 0
       ));
};

const App = ({ match, modules, authUser }) => {
       const canAccessPointOfInterest = hasPointOfInterestAccess(authUser);
       return (
       <div className="printView gx-main-content-wrapper">
              <Switch>
                     <Route key='dashboard' path={`${match.url}dashboard`}
                            render={(props) => <Dashboard resourceName={'Dashboard'} {...props} />}
        /*component={asyncComponent(() => import('../containers/Dashboard'))}*/ />
                     <Route key={'JobCardAllocation'} path={`${match.url}job-card-allocation`}
                            render={(props) => <JobCardAllocation resourceName={'Activity'} {...props} />} />
                     <Route key={'JobCardDateUpdate'} path={`${match.url}job-card-date-update`}
                            render={(props) => <JobCardStatusUpdate resourceName={'JobCard'} {...props} />} />
                     <Route key={'JobCardStatus'} path={`${match.url}job-card-status`}
                            render={(props) => <JobCardStatus resourceName={'JobCard'} {...props} />} />
                     <Route key={'JobCardClosure'} path={`${match.url}job-card-closure`}
                            render={(props) => <JobCardClosure resourceName={'JobCard'} {...props} />} />
                     <Route key={'ChangePassword'} path={`${match.url}change-password`}
                            render={(props) => <ChangePassword resourceName={'ChangePassword'} />} />
                     <Route key={'SpareInventory'} path={`${match.url}spare-inventory-report`}
                            render={(props) => <SpareInventoryReport resourceName={'SparePart'} {...props} />} />
                     <Route key={'SalesReport'} path={`${match.url}sale-order/sales-report`}
                            render={(props) => <SalesReport resourceName={'SaleOrder'} {...props} />} />
                     <Route key={'SpareStockTakingAdjustmentDetails'} path={`${match.url}spare-stock-taking-adjustment/:voucherNo`}
                            render={(props) => <SpareStockTakingAdjustmentDetails resourceName={'Report'} {...props} />} />
                     <Route key={'SpareAdjustmentVoucherReport'} path={`${match.url}spare-adjustment-vouchers`}
                            render={(props) => <SpareAdjustmentVoucherReport resourceName={'SpareStockTaking'} {...props} />} />
                     <Route key={'SpareCompatibility'} path={`${match.url}spare-compatibility-report/:id?`}
                            render={(props) => <SpareCompatibility resourceName={'SparePart'} {...props} />} />
                     <Route key={'SpareMerge'} path={`${match.url}spare-part-merge`}
                            render={(props) => <SpareMerge resourceName={'SparePart'} {...props} />} />
                     <Route key={'SpareSubAssembly'} path={`${match.url}asset/spare-report/:id?`}
                            render={(props) => <SubAssemblyReport resourceName={'Asset'} {...props} />} />
                     <Route key={'SpareModelReport'} path={`${match.url}asset/spare-issue-report/:id?`}
                            render={(props) => <AssetModelSpareIssueReport resourceName={'Asset'} {...props} />} />
                     <Route key={'deviceDetails'} path={`${match.url}iot/device-details/:asset/:id`}
                            render={(props) => <DeviceDetails resourceName={'Asset'} {...props} />} />
                     <Route key={'bleBeaconDetails'} path={`${match.url}iot/ble-beacon-details/:asset/:mac`}
                            render={(props) => <BleBeaconDetails resourceName={'Asset'} {...props} />} />
                     <Route key={'fuelCalibration'} path={`${match.url}iot/fuel-sensor-calibration/:asset/:id/:fsd?`}
                            render={(props) => <FuelSensolCalibSlab resourceName={'FuelSensor'} {...props} />} />
                     <Route key={'dailyIotReport'} path={`${match.url}iot/daily-iot-report`}
                            render={(props) => <DailyReport resourceName={'IotDevice'} {...props} />} />
                     <Route key={'iotDeviceReport'} path={`${match.url}iot/iot-device-report`}
                            render={(props) => <IotDeviceReport resourceName={'IotDevice'} {...props} />} />
                     <Route key={'iotDailyProcessCheck'} path={`${match.url}iot/iot-daily-process-check`}
                            render={(props) => <IotDailyProcessCheck resourceName={'IotDevice'} {...props} />} />
                     <Route key={'opsTicketsReport'} path={`${match.url}iot/tickets-report`}
                            render={(props) => <OpsTicketsReport {...props} />} />
                     <Route key={'bulkFuelImport'} path={`${match.url}bulk-fuel-import`}
                            render={(props) => <BulkFuelImport resourceName={'BulkFuelImport'} {...props} />} />
                     <Route key={'bulkFuelProcess'} path={`${match.url}bulk-fuel-process`}
                            render={(props) => <BulkFuelProcess resourceName={'BulkFuelProcess'} {...props} />} />
                     {authUser && authUser.superAdmin &&
                            <Route key={'dailyFuelProcessReportNotification'} path={`${match.url}daily-fuel-process-report-notification`}
                                   render={(props) => <DailyFuelProcessReportNotification resourceName={'DailyFuelProcessReportNotification'} {...props} />} />
                     }
                     {authUser && authUser.superAdmin &&
                            <Route key={'billingUnits'} path={`${match.url}billing-units`}
                                   render={(props) => <BillingUnits resourceName={'BillingUnits'} authUser={authUser} {...props} />} />
                     }
                     <Route key={'iotSetting'} path={`${match.url}iot/setting/:asset/:gps`}
                            render={(props) => <IotSettingPage resourceName={'IotSetting'} {...props} />} />
                     <Route key={'speedLimitBulk'} path={`${match.url}asset/speed-limit`}
                            render={(props) => <SpeedLimitBulkUpdate resourceName={'Asset'} {...props} />} />
                     <Route key={'assetBulkUpdate'} path={`${match.url}asset/bulk-asset-update`}
                            render={(props) => <BulkAssetUpdate resourceName={'Asset'} {...props} />} />
                     {/* <Route key={'bowserTransactionReport'} path={`${match.url}bowser-transaction-report`}
                            render={(props) => <BowserTransactionReport resourceName={'BowserTransactionReport'} {...props} />} /> */}
                     <Route key={'iotSupportJobs'} path={`${match.url}iot-support-jobs`}
                            render={(props) => <IotSupportJobsCardView resourceName={'IotSupportJobs'} {...props} />} />
                     <Route key={'alert'} path={`${match.url}alert`}
                            render={(props) => <Alert resourceName={'Alert'} {...props} />} />
                     {/* Asset Reclassification, ported from the AIM project. A static route
                         because the sidebar is driven by module records from the API and no
                         'AssetReclassification' module exists yet - reachable at
                         /asset-reclassification until one is added. Like the other
                         static routes it must precede the dynamic module routes below. */}
                     <Route key={'assetReclassification'} path={`${match.url}asset-reclassification`}
                            render={(props) => <AssetReclassification resourceName={'AssetModel'} {...props} />} />
                     {/* Spares Audit (PI purchases + SPI issues). Static route until the
                         backend registers a 'SparesAudit' module; the module route resolves to
                         the same /spares-audit path and the same container (containers map),
                         so nothing changes for users when it arrives. Access is checked inside
                         the screen. Must precede the dynamic module routes below. */}
                     <Route key={'sparesAudit'} path={`${match.url}spares-audit`}
                            render={(props) => <SparesAudit resourceName={'SparesAudit'} {...props} />} />
                     {/* Old reconciliation page kept as a backup. The module-driven
                         /reconciliation route now renders the new ReconciliationV2. This
                         static route must precede the dynamic module routes in the Switch. */}
                     <Route key={'reconciliationLegacy'} path={`${match.url}reconciliation-legacy`}
                            render={(props) => <ReconciliationLegacy resourceName={'Reconciliation'} {...props} />} />
                     {canAccessPointOfInterest &&
                            <Route key={'geoFenceImport'} path={`${match.url}geo-fence/import`}
                                   render={(props) => <GeoFenceImport resourceName={'PointOfInterest'} authUser={authUser} {...props} />} />
                     }
                     {canAccessPointOfInterest &&
                            <Route key={'geoFence'} path={`${match.url}geo-fence`}
                                   render={(props) => <GeoFence resourceName={'PointOfInterest'} authUser={authUser} {...props} />} />
                     }
                     {canAccessPointOfInterest &&
                            <Route key={'poiManager'} path={`${match.url}poi-manager`}
                                   render={(props) => <PoiManager resourceName={'PointOfInterest'} authUser={authUser} {...props} />} />
                     }
                     {
                            modules.map((module) => {
                                   if (module.name !== 'JobCard/Search' && module.name !== 'PointOfInterest') {
                                          return <Route key={module.name}
                                                 path={`${match.url}${sanitizeFieldName(module.name).toLowerCase().split(' ').join('-')}`}
                                                 render={(props) => React.createElement(containers[module.name], { resourceName: module.name, ...props })} />;
                                   }
                            }
                            )
                     }
              </Switch>
       </div>
);
}

export default App;
